<script>
  import { mapState } from 'vuex'
  export default {
    name: 'Input',
    props: ['form', 'placeholder', 'rules', 'field', 'label'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field]
        },
        set(v) {
          this.$store.dispatch('signup/SET_FIELD', { key: this.field, value: v })
        },
      },
    },
  }
</script>

<template>
  <v-text-field :placeholder="placeholder" :rules="rules" v-model="model" outlined light :label="label"></v-text-field>
</template>
